import AppConstant from '../../../../config/app.constants';

class LockOpenErrorsController {
  /*@ngInject*/
  constructor(Auth, User, Modal, LockOpenErrorService, UserBranchService, Navigation, $q, $translate, AtmCodesManagementService, $state, ResetAtmCodeService, $rootScope) {
    this.Auth = Auth;
    this.User = User;
    this.Modal = Modal;
    this.LockOpenErrorService = LockOpenErrorService;
    this.UserBranchService = UserBranchService;
    this.Navigation = Navigation;
    this.$q = $q;
    this.$translate = $translate;
    this.AtmCodesManagementService = AtmCodesManagementService;
    this.$state = $state;
    this.ResetAtmCodeService = ResetAtmCodeService;
    this.$rootScope = $rootScope;

    this.model = {
      branchObj: {
        results: [],
        totalRecords: 0
      },
      lockTypeObj: {
        results: [],
        totalRecords: 0
      },
      locationIdObj: {
        results: [],
        totalRecords: 0
      },
      ErrorObj: {
        results: [],
        totalRecords: 0
      },
      loggedInUser: User.getUser().id,
      branch: '',
      locationId: '',
      error: '',
      lockType: '',
      currentBranch: User.getUser().branchId,
      atmCodeList: [],
      loading: false,
      isExporting: false,
      dateRangeOption: {
        startDate: null,
        endDate: null,
      },
      dateRangPickerOptions: {},
      dateRangPickerOptionsfor: {},
    };
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/lock-open-errors');
  }

  $onInit() {
    this.$q.all([
      this.UserBranchService.getUserBranches(this.model.loggedInUser)
    ])
      .then((data) => {
        this.model.branchObj.results = data[0].results;
        this.model.branchObj.results.forEach((branch) => {
          branch.ticked = true;
        })

        this.setDateRangeOptions('dateRangPickerOptionsfor');
        // this.model.dateRangeOption.startDate = moment().startOf('week').format('YYYY-MM-DD HH:mm:ss');
        // this.model.dateRangeOption.endDate = moment().endOf('week').format('YYYY-MM-DD HH:mm:ss');

        setTimeout(() => {
          this.getATMCodes()
            .then(() => {
              this.model.atmCodeList.forEach((obj) => {
                if(obj.lockType) this.model.lockTypeObj.results.push({ Key: obj.lockType, Value: obj.lockType });
                this.model.locationIdObj.results.push({ Key: obj.locationId, Value: obj.locationId });
                this.model.ErrorObj.results.push({ Key: obj.message, Value: obj.message });
              })

              this.model.lockTypeObj.results = _.uniqBy(this.model.lockTypeObj.results, 'Key');
              this.model.locationIdObj.results = _.uniqBy(this.model.locationIdObj.results, 'Key');
              this.model.ErrorObj.results = _.uniqBy(this.model.ErrorObj.results, 'Key');
              this.model.lockTypeObj.totalRecords = this.model.lockTypeObj.results.length;
              this.model.locationIdObj.totalRecords = this.model.locationIdObj.results.length;
              this.model.ErrorObj.totalRecords = this.model.ErrorObj.results.length;
            })
        })
      })
      .catch((err) => {
        console.log(err);
        this.Modal.errorModal(err.data.message);
      })
  }

  getATMCodes() {
    const branchIds = this.model.branch.map(b => b.branchId);
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();

    this.model.loading = true;
    return this.LockOpenErrorService.getFailedToOpenLocks(branchIds, startDate, endDate)
      .then((data) => {
        this.model.atmCodeList = _.orderBy(data.results, ['createdAt'], ['desc']);
      })
      .catch((err) => {
        console.log(err);
        this.Modal.errorModal(err.data.message);
      })
      .finally(() => {
        this.model.loading = false;
      })
  }

  loadData() {
    setTimeout(() => {
      this.getATMCodes();
    })
  }

  resetBranchSelection() {
    this.model.branchObj.results.forEach((branch) => {
      if (branch.branchId == this.model.currentBranch) {
        branch.ticked = true;
      }
      else {
        branch.ticked = false;
      }
    })
  }

  filterRecords() {
    let branch = this.model.branch;
    let locationId = this.model.locationId ? this.model.locationId.Value : null;
    let lockType = this.model.lockType ? this.model.lockType.Value : null;
    let error = this.model.error ? this.model.error.Value : null;

    return function (row) {

      function filterByBranchId() {
        if (branch.length) return branch.some(function (data) { return row['branchId'].indexOf(data.branchId) > -1 })
        else return row['branchId'].indexOf('') > -1;
      }

      function filterByLocationId() {
        if (locationId) return row['locationId'] && row['locationId'].indexOf(locationId) > -1;
        else return row;
      }

      function filterByLockType() {
        if (lockType) return row['lockType'] && row['lockType'].indexOf(lockType) > -1;
        else return row;
      }

      function filterByError() {
        if (error) return row['message'] && row['message'].indexOf(error) > -1
        else return row;
      }

      return filterByBranchId() &&
        filterByLocationId() &&
        filterByLockType() &&
        filterByError()
    }
  };

  fixAtmCode(atmCodeObj) {
    if (this.allowOnce) return;
        this.allowOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('resetAtmCode.delete_open_code_error_message'),
            callback: (({
                modal,
                $scope
            }) => {
                this.allowOnce = true;
                this.delete(atmCodeObj, this.allowOnce);
                modal.close();
            }),
            negative: (({
                modal,
            }) => {
                this.allowOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
  }

  delete(atmCodeObj, allowOnce) {
    this.allowOnce = allowOnce;
    this.model.isDeleting = true
    this.ResetAtmCodeService.deleteAtmCode(atmCodeObj.cacheKey, atmCodeObj.branchId)
        .then((res) => {
            setTimeout(() => {
                this.getATMCodes(); // reload data after delete
            }, 500)
        })
        .catch((err) => {
            console.log(err)
        })
        .finally(() => {
            this.allowOnce = false;
            this.model.isDeleting = false;
        })
}

  exportData() {
    const reportPrefix = `Lock_Open_Errors(${moment().format('YYYY-MM-DD_HH:mm')})`;
    const branchIds = this.model.branch.map(b => b.branchId);
    const startDate = this.getStartDate();
    const endDate = this.getEndDate();

    this.model.isExporting = true;

    this.LockOpenErrorService.exportFailedToOpenLock(branchIds, startDate, endDate)
      .then((data) => {
        this.downloadFile(reportPrefix, data.reportData);
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.isExporting = false;
      })
  }

  downloadFile(reportPrefix, reportData) {
    const fileName = reportPrefix.concat('.csv');
    const a = document.createElement("a");
    document.body.appendChild(a);
    const file = new Blob([reportData], { type: 'application/csv' });
    const fileURL = window.URL.createObjectURL(file);
    a.href = fileURL;
    a.download = fileName;
    a.click();
  }

  goToServiceHistory(locationId) {
    return this.Navigation.goToLocationTab(locationId);
  }

  resetData() {
    this.model.dateRangeOption = {};
    this.model.locationId = '';
    this.model.error = '';
    this.model.lockType = '';
  }

  setDateRangeOptions(modelValue) {
    this.model[modelValue] = {
      autoApply: true,
      eventHandlers: {
        'apply.daterangepicker': () => {
          this.getATMCodes();
        }
      },
      ranges: {
        'Today': [
          moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Week': [
          moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
          moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
        ],
        // 'Current Month': [
        //   moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        //   moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
        // ],
      }
    }
  }

  getStartDate() {
    return this.model.dateRangeOption.startDate ? moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD HH:mm:ss') : null;
  }

  getEndDate() {
    return this.model.dateRangeOption.endDate ? moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD HH:mm:ss') : null;
  }

  translateOTCCompanyName(companyName) {
    if(!companyName) return;
    return this.$translate.instant('location.' + companyName);
  }

  goToUserTab(userId) {
    if (!userId) return;
    this.Navigation.goToUserTab(userId, null);
  }

}

export default LockOpenErrorsController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/lock_open_errors/lock_open_errors.controller.js